<template>
    <!-- 添加回复 -->
    <el-form :model="reply" ref="reply" :rules="rules" label-width="60px" style="margin-right:20px;">

      <el-form-item label="回复" prop="content">
        <EditorSummernote ref = "summernote_3"/>

        <TicketUploadList ref = "upList2"
          @clear="() => { this.$refs.up4.clearFile(); }"
          @delete="(e) => { this.$refs.up4.deleteFile(e); }"/>

        <div>
          <ReplyTicketButton @click="addNewReply" :askUpdateStatus="ticket && (ticket.orderStatus === 5 || ticket.orderStatus === 6)" ref="replyBtn"/>

          <el-button title="点我可将工单抄送给指定人" @click="ticketCcShow=!ticketCcShow;">抄送(通知)</el-button>

          <TicketTemplateSelect @selected="onTicketTemplateSelected"/>

          <TicketUpload ref="up4"
            @change="(e)=>{this.$refs.upList2.setAttachmentList(e);}"/>

          <TicketTaskFormDialog ref="ticketTaskFormDialog"
            @afterPost="afterPost"/>

          <el-button title="催办此工单"
            @click="hastenTicket"
            style="float:right;margin-left:5px;">催办</el-button>

          <!-- 审批按钮组 from -->
          <el-button
            v-if="workflowButtonShow"
            @click="onRejectTask_0"
            title="清除关联工作流,并将处理人更新为发起人"
            type="warning"
            style="float:right;margin-left:5px;">驳回</el-button>

          <el-button
            v-if="workflowButtonShow"
            @click="onCompleteTask_0"
            title="如果配置了审批步骤的表单,会弹出表单"
            type="success"
            style="float:right;">审批</el-button>

          <el-button
            v-if="workflowButtonNoPermissionShow"
            type="info"
            plain disabled
            :title="'流程中配置了需要指定的人来审批这个工单 ' + JSON.stringify(ticketDealUser)"
            style="float:right;">需要 {{ticketDealUser.name}} 审批</el-button>
          <!-- 审批按钮组 to -->

          <TicketWidgetGroup group="AfterTicketReplyButton" :ticketNo="ticketNo"/>
        </div>
    </el-form-item>

    <el-form-item v-if="ticketCcShow" label="抄送">
        <NoticeUserSearch @change="updateNoticeIdsReply" :id="reply.orderNoticeList"/>

        <span style="padding-left:20px;font-size:12px;color: #606266;">选择抄送人后，点击上面的
          <b style="color:DodgerBlue;">[回复]</b>
          按钮，才会生效
        </span>

        <span style="padding-left:10px;font-size:12px;color: #606266;">左栏下方也可以修改抄送人</span>
    </el-form-item>
    </el-form>
</template>

<script>
export default {
  name: "TicketReply",

  props : ["ticketNo", "ticket"],

  data() {
    return {
      ticketDealUser : {},
      workflowButtonShow : false,
      workflowButtonNoPermissionShow : false,
      ticketCcShow : false,
      token: null,

      rules: {
        content: [
          { required: true, message: '请输入回复内容', trigger: 'blur' }
        ]
      },

      reply: {
        content: '',
        orderNoticeList: [] //通知列表
      }
    };
  },

  watch : {
    ticket() {
      this.onTicketChange();
    }
  },

  methods: {
    afterPost() {
      this.$emit('change', null);
    },

    showStartFormDialog( _workflowId ) {
      this.$refs.ticketTaskFormDialog.showStartFormDialog( _workflowId , this.ticketNo);
    },

    showCompleteDialog( _ticketNo ) {
      this.$refs.ticketTaskFormDialog.showCompleteDialog( _ticketNo );
    },

    onTicketChange() {
      var _this = this;
      sdk.TicketWorkflowApi().showWorkflowButton({
        ticketNo : this.ticket.orderId
      }).then(res => {
        _this.workflowButtonShow = res.show;
        _this.workflowButtonNoPermissionShow = 'no_permission' == res.type;
        _this.ticketDealUser = res.expectUser;
      });
    },

    onCompleteTask_0() {
      this.$emit('completeTask', null);
    },

    onRejectTask_0() {
      this.$emit('rejectTask', null);
    },

    onTicketTemplateSelected(ticketTemplate) {
      if ( !ticketTemplate || !ticketTemplate.content ) {
        console.log("#55 ticketTemplate is empty", ticketTemplate);
        _message("模板为空");
        return;
      }

      var _editorContent = this.$refs.summernote_3.summernoteGetCode();
      var _newContent = "";
      if ( !!_editorContent ) {
        _newContent += _editorContent + "<br/><br/>";
      }

      _newContent += ticketTemplate.content;

      this.$refs.summernote_3.summernoteSetCode( _newContent );
    },

    //选择抄送人回调-添加回复
    updateNoticeIdsReply(value) {
      this.reply.orderNoticeList = [];
      value.map(item => {
        this.reply.orderNoticeList.push({'noticeUserId': item.id})
      });
    },

    //弹出层关闭-添加回复
    handleClose() {
      this.$refs['reply'].resetFields()
      this.reply.orderNoticeList = []
    },

    hastenTicket() {
      if ( !confirm('催一下?') ) {
        return;
      }

      var _this = this;
      sdk.TicketApi().hastenTicket({
        no : _this.ticketNo
      }).then(() => {
        _message('催办了这个工单');

        _this.$emit('change', null);
      });
    },

    //添加回复
    addNewReply(command, status) {
      var _this = this;
      _this.$refs.replyBtn.disable();

      _this.reply.content = this.$refs.summernote_3.summernoteGetCode();

      _this.$refs.reply.validate(valid => {
        if ( !valid || !_this.reply.content || '' == _this.reply.content || '<p><br></p>' == _this.reply.content ) {
          _message('必须输入回复内容');

          _this.$refs.replyBtn.enable();

          return false; // 校验不通过 表单未提交
        }

        var data = {
          'orderId': _this.ticketNo,
          'orderRemark.remarkContent': _this.reply.content,
          'orderNoticeList': _this.reply.orderNoticeList
        }

        if ( "privateReply" == command ) {
          data.visible = false;
        }

        data.attachmentList = _this.$refs.up4.getAttachmentList();

        _this.$http.post('/ticket/v2-workOrder/reply', data).then(response => {
          _this.$refs.replyBtn.enable();

          var result = response.data;

          if(result.status) {
            _message('已添加工单回复');

            _this.handleClose();
            _this.$refs.summernote_3.summernoteSetCode('');
            _this.$refs.upList2.deleteAll();

            _this.$emit('change', null);
          } else {
            console.log("#96 /reply error ", response);
            var msg = result.message ? result.message : "#97 请求接口失败";
            _this.$alert(msg)
          }
        }, response => {
          _this.$refs.replyBtn.enable();

          console.log("#100 /reply error ", response);
          _this.$alert('网络繁忙，请稍后重试！')
        });

        if (status) {
          sdk.TicketApi().updateStatus({
            no : _this.ticketNo,
            status : status
          }).then(()=>{
            _message('修改工单状态成功');
            _this.$emit('change', null);
          });
        }
      })
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketReply.vue